import { Heart } from "lucide-react";
import { useFavorites } from "../contexts/FavoritesContext";

/**
 * Reusable favorite (heart) toggle button.
 * Props:
 *  - track: full track object (needed for optimistic add)
 *  - size: "sm" | "md" | "lg"
 *  - variant: "icon" (transparent) | "pill" (with bg)
 */
export default function FavoriteButton({ track, size = "md", variant = "icon", className = "" }) {
    const { isFavorite, toggle } = useFavorites() || {};
    const fav = isFavorite ? isFavorite(track.id) : false;

    const handle = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (toggle) toggle(track);
    };

    const sizeCls = size === "sm" ? "w-7 h-7" : size === "lg" ? "w-11 h-11" : "w-9 h-9";
    const iconCls = size === "sm" ? "w-3.5 h-3.5" : size === "lg" ? "w-5 h-5" : "w-4 h-4";

    if (variant === "pill") {
        return (
            <button
                type="button"
                onClick={handle}
                className={`inline-flex items-center gap-1.5 px-3 py-2 rounded-full text-sm transition-colors ${
                    fav
                        ? "bg-[#FF6B9D]/15 text-[#FF6B9D] border border-[#FF6B9D]/40"
                        : "border border-[#262626] text-[#A8A8A8] hover:text-[#FF6B9D] hover:border-[#FF6B9D]/40"
                } ${className}`}
                aria-label={fav ? "Retirer des favoris" : "Ajouter aux favoris"}
                data-testid={`fav-pill-${track.id}`}
            >
                <Heart className={`${iconCls} ${fav ? "fill-[#FF6B9D]" : ""}`} />
                {fav ? "Favori" : "Ajouter"}
            </button>
        );
    }

    return (
        <button
            type="button"
            onClick={handle}
            className={`${sizeCls} rounded-full inline-flex items-center justify-center transition-all ${
                fav
                    ? "bg-[#FF6B9D]/15 text-[#FF6B9D] hover:bg-[#FF6B9D]/25"
                    : "bg-[#0F0F0F]/80 text-[#A8A8A8] hover:text-[#FF6B9D] backdrop-blur-sm border border-[#262626] hover:border-[#FF6B9D]/40"
            } ${className}`}
            aria-label={fav ? "Retirer des favoris" : "Ajouter aux favoris"}
            data-testid={`fav-btn-${track.id}`}
        >
            <Heart className={`${iconCls} ${fav ? "fill-[#FF6B9D]" : ""}`} />
        </button>
    );
}
